// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { InvoiceHeader } from './invoice-header';
import { JoDetail } from './jo-detail';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class InvoiceDetail extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  /**
   * Per-unit amount billed for a reissued (account-owned) unit. Add-ons ride along only when the
   * JO charges them on reissuance. The flag is a parameter rather than a lookup through
   * `invoiceHeader.joHeader` so this never silently returns the wrong rate when the back-navigation
   * hasn't been expanded.
   */
  calcUnitReissueAmt(chargeAddonsOnReissuance: boolean) {
    const reissue = this.joDetail?.unitReissueAmt ?? 0;
    const addon = chargeAddonsOnReissuance ? (this.joDetail?.unitCustomAmt ?? 0) : 0;
    return reissue + addon;
  }

  calcExtendedReissueAmt(chargeAddonsOnReissuance: boolean) {
    return this.calcUnitReissueAmt(chargeAddonsOnReissuance) * (this.redistributeQty ?? 0);
  }
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** String(10) FK invoiceHeader */
  invoiceHeaderId!: string;
  /** Int32 FK joDetail */
  joDetailId!: number;
  /** Int32 */
  redistributeQty?: number;
  /** Binary */
  rowVersion!: any;
  /** Int32 */
  shipQty?: number;
  /** FK invoiceHeaderId */
  invoiceHeader!: InvoiceHeader;
  /** FK joDetailId */
  joDetail!: JoDetail;
}

